import wrap from 'wraptile';
import humanizeRange from '@pluto/humanize-moment-range';

import {QCFilters} from '../../QCWorkflow/QCFilters/QCFiltersType';
import {SetQCJobs, GetQCJobsSummary} from '../../QCWorkflow/QCManager/QCManagerTypes';

export interface HandleMountParams {
    setQCJobs: SetQCJobs;
    resetQCJobs: () => void;
    setPage: (value: number) => void;
    setRowsPerPage: (value: number) => void;
    getQCJobsSummary: GetQCJobsSummary;
    params: QCFilters;
    query: URLSearchParams;
}

export const handleMount = wrap((props: HandleMountParams) => {
    const {
        setQCJobs,
        resetQCJobs,
        getQCJobsSummary,
        setPage,
        setRowsPerPage,
        params,
        query,
    } = props;
    
    const queryLimit: string | null = query.get('limit');
    
    getQCJobsSummary();
    
    if (queryLimit) {
        const queryOffset: string | null = query.get('offset');
        const limit = Number(queryLimit);
        const page: number = Number(queryOffset) / limit || 0;
        const [dateStart, dateEnd] = humanizeRange(params.dates);
        const [finishDateStart, finishDateEnd] = humanizeRange(params.finishDates);
        
        setRowsPerPage(limit);
        setPage(page);
        setQCJobs({
            ...params,
            dateStart,
            dateEnd,
            finishDateStart,
            finishDateEnd,
            limit: Number(queryLimit),
        });
        return;
    }
    
    setQCJobs({
        ...params,
        limit: params.limit,
    });
    
    return resetQCJobs;
});
